import React from "react";
import { PARAMETER_OPTIONS } from "../../constants";
import SelectParameters from "../inputs/select-parameters";

const {
  SETS,
  REPS,
  RPEAMRAP,
  LOAD,
  ROUNDS,
  TIME,
  DISTANCE,
  REST,
  FREEFORM,
  NONE,
} = PARAMETER_OPTIONS;

const { MUSCLE, ENDURANCE } = { MUSCLE: "Muscle", ENDURANCE: "Endurance" };

class ParametersInputComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { selected: MUSCLE };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderSelectParameter = this.renderSelectParameter.bind(this);
    this.handleQuickSelectChange = this.handleQuickSelectChange.bind(this);
  }

  handleQuickSelectChange(type) {
    const { updateOtherExerciseParameters } = this.props;
    switch (type) {
      case MUSCLE:
        updateOtherExerciseParameters([SETS, REPS, RPEAMRAP, LOAD], null);
        this.setState({ selected: MUSCLE });
        break;
      case ENDURANCE:
        updateOtherExerciseParameters([ROUNDS, TIME, DISTANCE, REST], null);
        this.setState({ selected: ENDURANCE });
        break;
      case FREEFORM:
        updateOtherExerciseParameters([FREEFORM, NONE, NONE, NONE], "0");
        this.setState({ selected: FREEFORM });
        break;
    }
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    let freeFormSelected = null;
    let copyParameters = [];

    if (value === FREEFORM) {
      freeFormSelected = name[9]; // where is the free form selected
      copyParameters = [NONE, NONE, NONE, NONE];
    } else {
      copyParameters = [...this.props.parameters];
    }

    copyParameters[name[9]] = value;

    this.props.updateOtherExerciseParameters(copyParameters, freeFormSelected);
  }

  renderSelectParameter(parameter, index) {
    const { form, intensityMeasure } = this.props;

    return (
      <div className="form-row-item" data-col="1/4" key={`parameter_${index}`}>
        <label>Parameter {this.props.freeFormSelected ? 1 : index + 1}</label>
        <SelectParameters
          value={parameter}
          index={index}
          handleChange={this.handleInputChange}
          form={form}
          intensityMeasure={intensityMeasure}
        />
      </div>
    );
  }

  render() {
    const { parameters, freeFormSelected, className } = this.props;

    return (
      <>
        <div className={"form-row quick-selector"} data-col="1/1">
          <div className="form-row-item ">
            <label>Quick Select</label>
            <div className="flex items-center gap-2 ">
              {[MUSCLE, ENDURANCE, FREEFORM].map((elem) => (
                <button
                  className="parameter-button"
                  data-button-type={
                    this.state.selected === elem ? "outline" : "secondary"
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleQuickSelectChange(elem);
                  }}
                  key={elem}
                >
                  {elem}
                </button>
              ))}
            </div>
          </div>
        </div>
        <div className="form-row" data-col="1/1">
          {!freeFormSelected
            ? parameters.map(this.renderSelectParameter)
            : this.renderSelectParameter(
                parameters[freeFormSelected],
                Number(freeFormSelected)
              )}
        </div>
      </>
    );
  }
}

export default ParametersInputComponent;
